<h2 mat-dialog-title>Confirm Delete</h2>

<mat-dialog-content>
    {{ data.message }}
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="close(false)">Cancel</button>
    <button mat-raised-button color="warn" (click)="close(true)">Delete</button>
</mat-dialog-actions>